export const regisConstants = {
  GET_INVITE_REQUEST: 'GET_INVITE_REQUEST',
  GET_INVITE_SUCCESS: 'GET_INVITE_SUCCESS',
  GET_INVITE_FAILURE: 'GET_INVITE_FAILURE',

  REGISTER_MANAGER_REQUEST: 'MANAGER_REGISTER_REQUEST',
  REGISTER_MANAGER_SUCCESS: 'MANAGER_REGISTER_SUCCESS',
  REGISTER_MANAGER_FAILURE: 'MANAGER_REGISTER_FAILURE',

  REGISTER_SIMPLE_MANAGER_REQUEST: 'MANAGER_SIMPLE_REGISTER_REQUEST',
  REGISTER_SIMPLE_MANAGER_SUCCESS: 'MANAGER_SIMPLE_REGISTER_SUCCESS',
  REGISTER_SIMPLE_MANAGER_FAILURE: 'MANAGER_SIMPLE_REGISTER_FAILURE',

  REGISTER_USER_REQUEST: 'MANAGER_USER_REQUEST',
  REGISTER_USER_SUCCESS: 'MANAGER_USER_SUCCESS',
  REGISTER_USER_FAILURE: 'MANAGER_USER_FAILURE',
  REGISTER_COMPLETE: 'REGISTER_COMPLETE',

  // CHECK_GROUP_REQUEST: 'CHECK_GROUP_REQUEST',
  // CHECK_GROUP_SUCCESS: 'CHECK_GROUP_SUCCESS',
  // CHECK_GROUP_FAILURE: 'CHECK_GROUP_FAILURE',
  // CHECK_GROUP_RESET:  'CHECK_GROUP_RESET',

  CHECK_ID_REQUEST: 'CHECK_ID_REQUEST',
  CHECK_ID_SUCCESS: 'CHECK_ID_SUCCESS',
  CHECK_ID_FAILURE: 'CHECK_ID_FAILURE',
  CHECK_ID_RESET: 'CHECK_ID_RESET',
  CHECK_RGSNO_RESET: 'CHECK_RGSNO_RESET',
  CHECKED_REGIST_NO: 'CHECKED_REGIST_NO',

  SET_JOIN_FLAG_USER: 'SET_JOIN_FLAG_USER',
  SET_JOIN_FLAG_CORP: 'SET_JOIN_FLAG_CORP',
  SET_JOIN_FLAG_LINK_CORP: 'SET_JOIN_FLAG_LINK_CORP',
  SET_JOIN_FLAG_UTH: 'SET_JOIN_FLAG_UTH',
  CHECKED_JOIN_FLAG: 'CHECKED_JOIN_FLAG',

  UTH_INFO_REQUEST: 'UTH_INFO_REQUEST',
  UTH_INFO_SUCCESS: 'UTH_INFO_SUCCESS',
  UTH_INFO_FAILURE: 'UTH_INFO_FAILURE',

  ADD_CRTFCT_REQUEST: 'ADD_CRTFCT_REQUEST',
  ADD_CRTFCT_SUCCESS: 'ADD_CRTFCT_SUCCESS',
  ADD_CRTFCT_FAILURE: 'ADD_CRTFCT_FAILURE',

  CHECK_MOBILE_REQUEST: 'CHECK_MOBILE_REQUEST',
  CHECK_MOBILE_SUCCESS: 'CHECK_MOBILE_SUCCESS',
  CHECK_MOBILE_FAILURE: 'CHECK_MOBILE_FAILURE',

  DUPLE_BIZNO_REQUEST: 'DUPLE_BIZNO_REQUEST',
  DUPLE_BIZNO_SUCCESS: 'DUPLE_BIZNO_SUCCESS',
  DUPLE_BIZNO_FAILURE: 'DUPLE_BIZNO_FAILURE',

  CHECK_CRTFCT_REQUEST: 'CHECK_CRTFCT_REQUEST',
  CHECK_CRTFCT_SUCCESS: 'CHECK_CRTFCT_SUCCESS',
  CHECK_CRTFCT_FAILURE: 'CHECK_CRTFCT_FAILURE',

  LINk_INFO_REQUEST: 'LINk_INFO_REQUEST',
  LINk_INFO_SUCCESS: 'LINk_INFO_SUCCESS',
  LINk_INFO_FAILURE: 'LINk_INFO_FAILURE',
}
